module.exports = __webpack_public_path__ + "img/plug.4e5ef741.jpg";